import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PhoneMissed = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "phone-missed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.94 16.64a4.34 4.34 0 00-.19-.73 1 1 0 00-.72-.65l-6-1.37a1 1 0 00-.92.26c-.14.13-.15.14-.8 1.38a10 10 0 01-4.88-4.89C9.71 10 9.72 10 9.85 9.85a1 1 0 00.26-.92L8.74 3a1 1 0 00-.65-.72 3.79 3.79 0 00-.72-.18A3.94 3.94 0 006.6 2 4.6 4.6 0 002 6.6 15.42 15.42 0 0017.4 22a4.6 4.6 0 004.6-4.6 4.77 4.77 0 00-.06-.76zM15.8 8.7a1.05 1.05 0 001.47 0L18 8l.73.73a1 1 0 001.47-1.5l-.73-.73.73-.73a1 1 0 00-1.47-1.47L18 5l-.73-.73a1 1 0 00-1.47 1.5l.73.73-.73.73a1.05 1.05 0 000 1.47z"
  }))));
});
PhoneMissed.displayName = 'PhoneMissed';
export var PhoneMissedDimensions = {
  height: 24,
  width: 24
};